export const SEO_GUEST_PROMPT_MS = 60 * 1000;
export const SEO_GUEST_LIMIT_MS = 10 * 60 * 1000;
// localStorage: jeden wspólny limit dla całej przeglądarki, także między kartami.
export const SEO_GUEST_STARTED_AT_KEY = "matematron.seoLearning.startedAt.v3";

export const MATURA_DEMO_LIMIT_MS = 10 * 60 * 1000;
export const MATURA_DEMO_STARTED_AT_KEY = "matematron.maturaDemo.startedAt.v2";
